import { render, staticRenderFns } from "./FacebookPixel.vue?vue&type=template&id=39961814&"
import script from "./FacebookPixel.vue?vue&type=script&lang=js&"
export * from "./FacebookPixel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports